var _circle, _circle2, _path, _path2, _g, _circle3, _circle4, _rect, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWikiMenuBike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3333,
    cy: 27.5,
    r: 4.16667,
    fill: "#5C5B5A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3333,
    cy: 27.5,
    r: 1.66667,
    fill: "#ECECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 23.5835V25.8333C6.66663 26.2936 7.03972 26.6667 7.49996 26.6667H24.9073C25.22 26.6667 25.5063 26.4917 25.6489 26.2134L26.0177 25.4939C26.1603 25.2157 26.4466 25.0406 26.7593 25.0406H33.0928C33.637 25.0406 34.0283 24.5276 33.8133 24.0277C33.594 23.5177 33.2902 22.9661 32.9166 22.6016C32.3715 22.0698 31.0464 21.5018 30.1257 21.1641C29.8009 21.045 29.5721 20.7472 29.5551 20.4017L29.2075 13.3323C29.1853 12.8794 29.5465 12.5 30 12.5V7.5H29.041C28.8544 7.5 28.6752 7.57294 28.5416 7.70325C28.4081 7.83356 28.2288 7.9065 28.0422 7.9065H23.3333C22.8731 7.9065 22.5 8.2796 22.5 8.73984V9.53252C22.5 9.99276 22.8731 10.3659 23.3333 10.3659H24.5833L23.8065 20.9755C23.7746 21.4109 23.412 21.748 22.9754 21.748H20C19.5397 21.748 19.1666 21.3749 19.1666 20.9146V18.3333C19.1666 17.8731 18.7935 17.5 18.3333 17.5H9.71911C9.38424 17.5 9.0819 17.7004 8.95153 18.0089L6.73238 23.2591C6.68898 23.3617 6.66663 23.4721 6.66663 23.5835Z",
    fill: "#D1CFCD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1451_18386",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 23.5835V25.8333C6.66663 26.2936 7.03972 26.6667 7.49996 26.6667H24.9073C25.22 26.6667 25.5063 26.4917 25.6489 26.2134L26.0177 25.4939C26.1603 25.2157 26.4466 25.0406 26.7593 25.0406H33.0928C33.637 25.0406 34.0283 24.5276 33.8133 24.0277C33.594 23.5177 33.2902 22.9661 32.9166 22.6016C32.3715 22.0698 31.0464 21.5018 30.1257 21.1641C29.8009 21.045 29.5721 20.7472 29.5551 20.4017L29.2075 13.3323C29.1853 12.8794 29.5465 12.5 30 12.5V7.5H29.041C28.8544 7.5 28.6752 7.57294 28.5416 7.70325C28.4081 7.83356 28.2288 7.9065 28.0422 7.9065H23.3333C22.8731 7.9065 22.5 8.2796 22.5 8.73984V9.53252C22.5 9.99276 22.8731 10.3659 23.3333 10.3659H24.5833L23.8065 20.9755C23.7746 21.4109 23.412 21.748 22.9754 21.748H20C19.5397 21.748 19.1666 21.3749 19.1666 20.9146V18.3333C19.1666 17.8731 18.7935 17.5 18.3333 17.5H9.71911C9.38424 17.5 9.0819 17.7004 8.95153 18.0089L6.73238 23.2591C6.68898 23.3617 6.66663 23.4721 6.66663 23.5835Z",
    fill: "#D1CFCD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1451_18386)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.3333,
    cy: 26.6666,
    r: 5,
    fill: "#C6C6C6"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.3333,
    cy: 27.5,
    r: 4.16667,
    fill: "#5C5B5A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.3333,
    cy: 27.5,
    r: 1.66667,
    fill: "#ECECEC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.33325,
    y: 15,
    width: 10.8333,
    height: 2.5,
    rx: 1.25,
    fill: "#5C5B5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 7.5H30.8333C31.7538 7.5 32.5 8.24619 32.5 9.16667V10.8333C32.5 11.7538 31.7538 12.5 30.8333 12.5H30V7.5Z",
    fill: "#FF791C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiMenuBike);
export default __webpack_public_path__ + "static/media/wikiMenuBike.666502bbb01c3c697833aa26749e578b.svg";
export { ForwardRef as ReactComponent };